import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Alert,
  Avatar,
  Box,
  IconButton,
  Slide,
  Snackbar,
  Typography,
} from "@mui/material";
import QuickreplyIcon from "@mui/icons-material/Quickreply";
import { connect } from "react-redux";

const headCellSx = {
  borderBottom: "1px solid #2a2a2a",
  color: "#777",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  backgroundColor: "#111",
  py: 1.5,
};

const rowSx = {
  cursor: "pointer",
  transition: "0.2s",
  "& td": { borderBottom: "1px solid #1e1e1e", color: "#ccc" },
  "&:hover": { backgroundColor: "#1f1f1f", "& td": { color: "#FFC001" } },
};

const ListingTableHeadings = [
  "",
  "Reviewer",
  "Listing/Service Name",
  "Category",
  "Price",
  "Actions",
];

const ListingsList = ({
  data,
  setReview,
  setOpenReview,
  setOpenDisputeModal,
}) => {
  const [snackbarStates, setSnackbarStates] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarStates({ ...snackbarStates, open: false });
  };

  const handleOpenDisputeModal = (event, data) => {
    event.stopPropagation();
    setOpenDisputeModal(true);
    setReview(data);
  };

  const handleDisplayReview = (data) => {
    setReview(data);
    setOpenReview(true);
  };

  return (
    <>
      <Snackbar
        transitionDuration={{ enter: 1000, exit: 2000 }}
        TransitionComponent={Slide}
        TransitionProps={{ enter: true, exit: false }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbarStates.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          variant="filled"
          sx={{ width: "100%" }}
          severity={snackbarStates.severity}
        >
          {snackbarStates.message}
        </Alert>
      </Snackbar>
      <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", overflow: "hidden" }}>
        {data && data.length > 0 ? (
          <Box sx={{ overflowX: "auto" }}>
            <Table sx={{ borderCollapse: "collapse" }}>
              <TableHead>
                <TableRow>
                  {ListingTableHeadings.map((item) => (
                    <TableCell key={item} align="center" sx={headCellSx}>
                      {item}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((item) => (
                  <TableRow
                    key={item.id}
                    sx={rowSx}
                    onClick={() => handleDisplayReview(item)}
                  >
                    <TableCell align="left" sx={{ width: 0, p: "8px 12px" }}>
                      <Avatar
                        alt={item.id}
                        src={item.user.avatar_url}
                        sx={{ width: 40, height: 40 }}
                      />
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px", width: "8%" }}>
                      {item.user.full_name}
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px" }}>
                      {item.reviewable.name}
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px" }}>
                      {item.reviewable.category_or_service.category.name}
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: "13px", color: "#FFC001 !important", fontWeight: 700 }}>
                      ${item.reviewable.price}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        onClick={(event) => handleOpenDisputeModal(event, item)}
                        sx={{ color: "#666", "&:hover": { color: "#FFC001", backgroundColor: "rgba(255,192,1,0.08)" } }}
                        size="small"
                      >
                        <QuickreplyIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        ) : (
          <Box
            display="flex"
            alignItems="center"
            sx={{ py: 8 }}
            justifyContent="center"
            flexDirection="column"
          >
            <Typography sx={{ fontSize: "14px", color: "#555" }}>
              No reviews yet.
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

const mapStateToProps = ({ Auth }) => ({
  jwtToken: Auth.jwtToken,
  user: Auth.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ListingsList);
